import request from "./../utils/request";
import store from "../store";
import { PERMISSION_TYPES } from "../language/permissionTypes";
import { checkPermission } from "../utils/PermissionUtils";
import log2 from "../utils/log2";

const log = log2("api.content");

export function getContents(perPage = 1000, page = 1) {
    return request({
        url: `/preparedContents/pagination`,
        method: "get",
        params: {
            pageCount: page,
            perPage: perPage,
        },
        timeout: 1000 * 10,
    });
}

export function createContent(data) {
    const permissionType = PERMISSION_TYPES["prepared.create"].tr.name;
    const isPermissionEnough = checkPermission(store.state.auth.user, permissionType, !!store.state.auth.adminUser);
    if (isPermissionEnough) {
        return request({
            url: "/preparedContents/",
            method: "post",
            data: data,
        });
    } else {
        log.error(`Permission is not enough ${permissionType}`);
        return Promise.reject(new Error(`Permission required for this action: ${permissionType}`));
    }
}

export function updateContent(id, data) {
    return request.put(`/preparedContents/${id}`, data);
}

export function deleteContent(id) {
    return request.delete(`/preparedContents/${id}`);
}
